// src/components/layout/Layout.js
import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

const Layout = ({ children }) => {
  let pathname = window.location.pathname;
  const page = pathname.split('/')?.[1];

  if (page?.includes('kiosk')) {
    return <main className="pt-[20px]">{children}</main>;
  }

  return (
    <>
      <Navbar />

      <main className="pt-[48px] md:pt-[51px]">{children}</main>

      {/* <Footer /> */}
    </>
  );
};

export default Layout;
